export const formatPhone = (phone: string) => {
  const regexp = /(\+[1-9]|[1-9])([0-9]{3})([0-9]{3})([0-9]{2})([0-9]{2})/;
  const input = phone.match(regexp);
  let output;
  if (input?.length) {
    output = `${input[1]} (${input[2]}) ${input[3]}-${input[4]}-${input[5]}`;
  }
  return output;
};
